import { useState } from "react";
import { Link } from "react-router-dom";
import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { PROJECTS } from "@/lib/data";

const FILTERS = ["All", "Websites", "Hospitality", "Service Business", "Concept"];

export default function Work() {
  const [filter, setFilter] = useState("All");
  const shown = PROJECTS.filter((p) =>
    filter === "All" ? true :
    filter === "Websites" ? p.tags.includes("Website") :
    filter === "Concept" ? p.type === "Concept" :
    p.tags.includes(filter));
  return (
    <>
      <PageHero eyebrow="Work" title="Selected" accent="work."
        subtitle="A growing portfolio of premium websites and concepts. Every project is designed from scratch around the individual business." />
      <section className="bg-paper text-ink">
        <div className="mx-auto max-w-[1440px] px-6 py-16 md:px-12 md:py-24">
          <div className="flex flex-wrap gap-3">
            {FILTERS.map((f) => (
              <button key={f} data-testid={`filter-${f.toLowerCase().replace(/ /g, "-")}`} onClick={() => setFilter(f)}
                className={`border px-5 py-2.5 text-[11px] uppercase tracking-label transition-colors duration-300 ${filter === f ? "border-ink bg-ink text-paper" : "border-ink/20 text-ink/70 hover:border-ink/60"}`}>{f}</button>
            ))}
          </div>
          <div className="mt-12 grid gap-6 sm:grid-cols-2">
            {shown.map((p, i) => (
              <Reveal key={p.slug} delay={(i % 2) * 0.06}>
                <Link to={`/work/${p.slug}`} data-testid={`work-card-${p.slug}`} className="group relative block aspect-[4/3] overflow-hidden">
                  <img src={p.image} alt={p.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-[1.2s] ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-105" />
                  <div className="absolute inset-0 bg-gradient-to-t from-ink/85 via-ink/10 to-transparent" />
                  <div className="absolute inset-x-0 bottom-0 p-6 text-white"><p className="text-[10px] uppercase tracking-label text-champagne">{p.type}</p><h3 className="mt-1 font-serif text-2xl">{p.title}</h3><p className="mt-1 text-[10px] uppercase tracking-label text-white/70">{p.tags.join(" · ")}</p></div>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
